import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { ChatMessage, ChatMessageFormatEnum } from '../Chat'
import { ChatSender } from '../ChatSender'

@InputType()
export class AddChatMessageArgs extends ActionArgs {
  @Field(() => String)
  content: string

  @Field(() => String)
  format: ChatMessageFormatEnum

  @Field(() => Boolean)
  isPublic: boolean

  @Field(() => String)
  chatId?: string

  @Field(() => String)
  extenalId?: string

  @Field(() => [ChatSender])
  collaborators?: ChatSender[]

  @Field(() => ChatSender)
  sender?: ChatSender

  @Field(() => String)
  subject?: string

  @Field(() => String)
  status?: string
}
export interface IAddChatMessage extends IAction<ChatMessage, AddChatMessageArgs> {}
